import { NavLink, Outlet } from 'react-router-dom';
import { BRANCH_LABELS } from '@lorsamthai/ops-shared';
import { useAuth } from '../auth/context.js';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 text-sm font-medium rounded-md ${
    isActive ? 'bg-slate-900 text-white' : 'text-slate-700 hover:bg-slate-100'
  }`;

export default function Shell() {
  const { me, logout } = useAuth();
  if (!me) return null;
  const branchLabel = me.branch ? BRANCH_LABELS[me.branch] : 'ทุกสาขา';

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-6">
            <div>
              <div className="text-sm font-semibold tracking-tight">ล.สามไทย · Ops</div>
              <div className="text-xs text-slate-500">
                {me.name} · {me.role === 'super_admin' ? 'Super' : branchLabel}
              </div>
            </div>
            <nav className="hidden gap-1 sm:flex">
              <NavLink to="/" end className={navLinkClass}>หน้าหลัก</NavLink>
              <NavLink to="/order-day" className={navLinkClass}>📋 สั่งรวม</NavLink>
              <NavLink to="/order-day-by-branch" className={navLinkClass}>🏪 สั่งแยกคลัง</NavLink>
              <NavLink to="/transfer-day" className={navLinkClass}>🚚 โอนวันนี้</NavLink>
              <NavLink to="/stock" className={navLinkClass}>Stock</NavLink>
              <NavLink to="/pos" className={navLinkClass}>PO</NavLink>
              <NavLink to="/transfers" className={navLinkClass}>Transfer</NavLink>
            </nav>
          </div>
          <button
            onClick={logout}
            className="rounded-md border border-slate-200 px-3 py-1.5 text-xs text-slate-600 hover:bg-slate-50"
          >
            ออก
          </button>
        </div>
        {/* mobile nav */}
        <nav className="flex gap-1 overflow-x-auto border-t border-slate-100 px-4 py-2 sm:hidden">
          <NavLink to="/" end className={navLinkClass}>หน้าหลัก</NavLink>
          <NavLink to="/order-day" className={navLinkClass}>📋 สั่งรวม</NavLink>
          <NavLink to="/order-day-by-branch" className={navLinkClass}>🏪 แยกคลัง</NavLink>
          <NavLink to="/transfer-day" className={navLinkClass}>🚚 โอน</NavLink>
          <NavLink to="/stock" className={navLinkClass}>Stock</NavLink>
          <NavLink to="/pos" className={navLinkClass}>PO</NavLink>
          <NavLink to="/transfers" className={navLinkClass}>รายการโอน</NavLink>
        </nav>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
